import styled from "@emotion/styled";

export const Group = styled.fieldset`
  background: var(--background);
  border: 1px solid ${(props) => props.theme.palette.disabled.base};
  border-radius: ${(props) => props.theme.baseUnit}rem;
  padding: ${(props) => props.theme.baseUnit}rem
    ${(props) => props.theme.baseUnit * 2}rem;
`;
